// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__7wr-Q","footer":"ModalCreateQualiphyProcedure_footer__DXXVK","additionData":"ModalCreateQualiphyProcedure_additionData__2BOa_"};